var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SMALL_SIZE, MEDIUM_SIZE, DEFAULT_SIZE, LARGE_SIZE, } from "../hooks/useUtilityStyles";
import { EXTRA_SMALL_BREAK, LARGE_BREAK, MEDUIM_BREAK, SMALL_BREAK, } from "./breakpoints.styles";
export var calculateDimension = function (dimension) {
    switch (dimension) {
        case "small":
            return SMALL_SIZE;
        case "medium":
            return MEDIUM_SIZE;
        case "default":
            return DEFAULT_SIZE;
        case "large":
            return LARGE_SIZE;
        case "zero":
            return 0;
        default:
            return {};
    }
};
export var calculateWidth = function (width) {
    var _a, _b, _c, _d;
    if (width === undefined)
        return {};
    if (typeof width === "number" || typeof width === "string")
        return width;
    var calculatedWidth = {};
    if (width.extraSmall) {
        calculatedWidth = __assign(__assign({}, calculatedWidth), (_a = {}, _a[EXTRA_SMALL_BREAK] = {
            width: width.extraSmall,
        }, _a));
    }
    if (width.small) {
        calculatedWidth = __assign(__assign({}, calculatedWidth), (_b = {}, _b[SMALL_BREAK] = {
            width: width.small,
        }, _b));
    }
    if (width.medium) {
        calculatedWidth = __assign(__assign({}, calculatedWidth), (_c = {}, _c[MEDUIM_BREAK] = {
            width: width.medium,
        }, _c));
    }
    if (width.large) {
        calculatedWidth = __assign(__assign({}, calculatedWidth), (_d = {}, _d[LARGE_BREAK] = {
            width: width.large,
        }, _d));
    }
    return calculatedWidth;
};
